import get from 'lodash/get';
import Raven from 'raven-js';
import shouldLogToSentry from '../../common/utils/shouldLogToSentry';

export default function apiClientEffectsErrorCallback(err) {
  if (!shouldLogToSentry()) {
    // eslint-disable-next-line no-console
    console.error(err);
    return;
  }

  if (!err.response || err.statusCode >= 500) {
    Raven.captureException(err, {
      extra: {
        serial: get(err, 'config.params.serial'),
      },
      tags: {
        apiRequestUrl: get(err, 'config.url'),
      },
    });
  }
}
